export default __webpack_public_path__ + "static/media/big-rocket.93147687.svg";